<app-chat-tab-shell [contractId]="contractId()" [documentTypeId]="documentTypeId()" [projectId]="projectId()" [embeddingsStatus]="embeddingsStatus()" />
